// extracted by mini-css-extract-plugin
export default {"rotaionBox":"ButtonListController_rotaionBox__AD76f"};